import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollResetter() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // 🔁 Supprimer backdrop Bootstrap résiduel
    document.body.classList.remove("modal-open", "offcanvas-backdrop", "show");
    document.body.style.overflow = "auto";

    // Supprimer manuellement tout backdrop restant
    document.querySelectorAll(".modal-backdrop, .offcanvas-backdrop").forEach((el) => el.remove());

    // Supprimer les éléments Bootstrap résiduels
    const openOffcanvas = document.querySelector(".offcanvas.show");
    if (openOffcanvas) openOffcanvas.classList.remove("show");

  }, [location]);

  return null;
}
